import React, {useState} from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import ScrollView from 'devextreme-react/scroll-view';
import LeftContainer from './LeftContainer'

import * as utils from '../../common/utils';
import _ from 'lodash'


export default (props) => {

    const template = props.defaultTemplate

    const addCard = () => {
        let tpl = _.cloneDeep(template)
        tpl.push({
            id: 'custom_' + utils.getRandomNum(),
            title: '',
            iconCls: 'customize',
            isActive: true,
            layout: []
        }
        )
        props.updateTemplate(tpl)
    }

    const cloneItem = (i) => {
        let tpl = _.cloneDeep(template);
        let item = _.cloneDeep(tpl[i])
        item.id = 'cloned_' + utils.getRandomNum()
        let cnt = 1;
        tpl.map(data => {
            if (data.title.indexOf(`${item.title}_Clone`) > -1) {
                cnt = cnt + 1;
            }
        })
        
        let cloneCnt = cnt > 1 ? cnt : '';
        item.title = item.title + '_Clone' + cloneCnt
        item.isActive = true
        tpl.push(item)

        props.updateTemplate(tpl, item.title + ' is cloned successfully.')
    }

    const deleteCard = (id) => {
        let tpl = _.cloneDeep(template);
        let title = '';
        let updatedTpl = _.remove(tpl, (v) => {
            title = v.title
            return v.id !== id;
        })
        
        props.updateTemplate(updatedTpl, title+ ' deleted.');
    }

    const saveCard = (obj) => {
       
        props.updateTemplate(template.map(item => {
            if (item.id == obj.id) {
                item.title = obj.title;
                item.iconCls = obj.iconCls;

            }
            return item;
        }));
    }


    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: true,
        scrollByThumb: true,
    }

 

  

    return (
        <div className="left-sidebar">
            
            <DndProvider backend={HTML5Backend}>
                <ScrollView className="left-menu-height" 
                    id="custom_left_menu"
                    {...scrollConfig}
                >
                <LeftContainer
                        template={template}
                        deleteCard={deleteCard}
                        saveCard={saveCard}
                        updateActiveItem={props.updateActiveItem}
                        updateTemplate={props.updateTemplate}
                        setVisibility={props.setVisibility}
                        cloneItem={cloneItem}
                        activeMenu={props.activeMenu}
                    />
                </ScrollView>
            </DndProvider>
           
            
            <div id="addNew" className="add-new" onClick={addCard}  >+ Add New</div>
        </div>
        )

}